import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { Secretary } from "../types/secretary.definition";

function useSecretary(): Secretary {
  const { session } = useSelector((state: RootState) => state.session);

  return useMemo(() => {
    const { user, metadata } = session ?? {};
    // Merge the user, secretary metadata, and appointment into a single secretary object
    const secretary: Secretary = {
      ...user,
      ...metadata?.secretary,
      userId: user?.id,
      id: metadata?.secretary?.id,
      photoUrl: user?.photoUrl,
      email: user?.email,
      civility: user?.civility,
      roleName: user?.roleName,
      firstName: user?.firstName,
      phoneNumber: user?.phoneNumber,
      lastName: user?.lastName,
      preferredNotificationMethods: user?.preferredNotificationMethods || [],
    } as Secretary;

    return secretary;
  }, [session]);
}

export default useSecretary;
